import { render, staticRenderFns } from "./Servicehall.vue?vue&type=template&id=aa170816&scoped=true&"
import script from "./Servicehall.vue?vue&type=script&lang=js&"
export * from "./Servicehall.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/hall.css?vue&type=style&index=0&id=aa170816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa170816",
  null
  
)

export default component.exports